import React from "react";

interface PermissionAlertProps {
  onCancel: () => void;
}

const PermissionAlert: React.FC<PermissionAlertProps> = ({ onCancel }) => {
  return (
    <div className="w-full max-w-md p-6 text-white ">
      <div className="text-lg font-bold ">Разрешение на уведомления</div>
      <div className="text-left  py-3 text-base font-normal w-full">Для получения уведомлений пожалуйста, разрешите уведомления в настройках браузера.</div>
      <div className="flex justify-end pt-4">
        <button className={`text-left px-6 py-3 text-base font-normal pt-2 pb-2  text-center `} onClick={onCancel}>Ок</button>  
      </div>
    </div>
  );
};

export default PermissionAlert;